export const laIpAddressType = 'ip_address';
